import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';


export const fetchUserAccess = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchUserAccessAction => {
  return {
    type: actionsTypes.FETCH_USERACCESS,
    query,
    callback
  };
};



export const fetchSearchUserAccess = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchSearchAction => {
  return {
    type: actionsTypes.FETCH_SEARCH_USERACCESS,
    query,
    callback
  };
};

export const setSearchUserAccess = (searches: actionsInterfaces.IUserAccess[]): actionsInterfaces.ISetSearchAction => {
  return {
    type: actionsTypes.SET_SEARCH_USERACCESS,
    searches,
  };
};




export const getUserAccessByEmail = (email: string, callback?: (result: actionsInterfaces.IUserAccess | null, error: any) => void): actionsInterfaces.IGetUserAccessByEmailAction => {
  return {
    type: actionsTypes.GET_USERACCESS_BY_EMAIL,
    email,
    callback,
  }
}

export const setUserAccesses = (userAccesses: actionsInterfaces.IUserAccess[]): actionsInterfaces.ISetUserAccessesAction => {
  return {
    type: actionsTypes.SET_USERACCESSES,
    userAccesses    
  };
};

export const addUserAccess = (userAccess: actionsInterfaces.IUserAccess, callback: IAsyncActionCallback): actionsInterfaces.IPostUserAccessAction => {
  return {
    type: actionsTypes.ADD_USERACCESS,
    userAccess: userAccess,    
    callback
  };  
};

export const putUserAccess = (userAccess: actionsInterfaces.IUserAccess, callback: IAsyncActionCallback): actionsInterfaces.IPutUserAccessAction => {
  return {
    type: actionsTypes.UPDATE_USERACCESS,
    userAccess: userAccess,    
    callback
  };  
};

export const setUserAccess = (userAccess: actionsInterfaces.IUserAccess): actionsInterfaces.ISetUserAccessAction=> {
  return {
    type: actionsTypes.SET_USERACCESS,
    userAccess
  };
}



export const addSuccess = (response: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS,
    response,
  };
};

export const putSuccess = (response: actionsInterfaces.IUserAccess)=> {
  return {
    type: actionsTypes.PUT_SUCCESS,
    response,
  };
};



export const deleteUserAccess = (item: actionsInterfaces.IUserAccess,  callback?: (result: any, error: any) => void): actionsInterfaces.IDeleteUserAccessAction => {
  return {
    type: actionsTypes.DELETE_USERACCESS,    
    item,
    callback
  };
};


export const clearDeleteUserAccess = (): actionsInterfaces.IDeleteUserAccessSuccess => {
  return {
    type: actionsTypes.CLEAR_DELETE_USERACCESS
  };
};

export const deleteUserAccessSuccess = (): actionsInterfaces.IDeleteUserAccessSuccess => {
  return {
    type: actionsTypes.DELETE_USERACCESS_SUCCESS
  };
};